// extracted by mini-css-extract-plugin
export default {"modulesScrollbarWrapper":"xyvMZ","scrollbarWrapper":"fJuZj"};